import State from "slotworks/state-machine/states/state";
import Components from "slotworks/components/components";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contract";
import { sequence, parallel } from "slotworks/utils/race-utils";
import * as TweenJS from "slotworks/utils/tween";
import G288SpinReelTransition from "components/matrix/transitions/spin-reel-transition";
import slotDefinition from "slotworks/model/slot-definition";

export const LOW_SYMBOLS = ["A", "K", "Q", "J", "10", "9"];

export default class LowToHigh extends State {

    public onEnter() {
        sequence([
            () => Contract.getTimeoutContract(500),
            () => this.transformSymbols(),
            () => Contract.getTimeoutContract(500)
        ]).then(() => this.complete());
    }

    public complete() {
        const reelTransition = Components.matrix.getTransition() as G288SpinReelTransition;
        const fsReelset = slotDefinition.reelsets.get("freespins");
        reelTransition.setReelset(fsReelset);
        super.complete();
    }

    private transformSymbols():Contract<void> {
        const symbols: SymbolComponent[] = [];
        const reels = Components.matrix.getReels();
        const filterLow = (symbol: SymbolComponent) => {
            if (LOW_SYMBOLS.indexOf(symbol.symbolId) >= 0) {
                symbols.push(symbol);
            }
        };
        for (let reel of reels) {
            reel.getSymbols().forEach(filterLow);
        }
        const funcs: (() => Contract<void>)[] = [];
        for (let i = 0; i < symbols.length; i++) {
            const symbol = symbols[i];
            funcs.push(() => sequence([ 
                () => this.shake(symbol, 3 + i * 3),
                () => symbol.stop() ]));
        }

        return parallel(funcs);
    }

    private shake(symbol:SymbolComponent, repeat: number = 1): Contract<void> {
        return new Contract(resolve => {
            const transform = symbol.getTransform();
            const tweened = transform.clone();
            const offsetX = -10 + Math.random() * 20;
            const offsetY = -10 + Math.random() * 20;
            new TweenJS.Tween(tweened)
            .to({x: transform.x + offsetX, y: transform.y + offsetY}, 60)
            .yoyo(true)
            .onUpdate(() => {
                symbol.setTransform(tweened);
                symbol.updateTransform();
            })
            .repeat(repeat)
            .onComplete(() => {
                symbol.setTransform(transform);
                symbol.updateTransform();
                resolve(null);
            })
            .start();            
        });
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/low-to-high.ts